'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _BaseModel2 = require('./BaseModel');

var _BaseModel3 = _interopRequireDefault(_BaseModel2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LeadSourceModel = (0, _classAutobindDecorator2.default)(_class = (_class2 = function (_BaseModel) {
  _inherits(LeadSourceModel, _BaseModel);

  // istanbul ignore next
  function LeadSourceModel() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var flatStore = arguments[1];

    _classCallCheck(this, LeadSourceModel);

    var _this = _possibleConstructorReturn(this, (LeadSourceModel.__proto__ || Object.getPrototypeOf(LeadSourceModel)).call(this, flatStore));

    _initDefineProp(_this, 'cases', _descriptor, _this);

    _initDefineProp(_this, 'category', _descriptor2, _this);

    _initDefineProp(_this, 'id', _descriptor3, _this);

    _initDefineProp(_this, 'name', _descriptor4, _this);

    _this.extend(data);
    return _this;
  }

  _createClass(LeadSourceModel, [{
    key: 'serialize',
    value: function serialize() {
      var SERIALIZE_FIELDS = ['cases', 'category', 'id', 'name'];
      return (0, _mobx.toJS)((0, _pick3.default)(this, SERIALIZE_FIELDS));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LeadSourceModel;
}(_BaseModel3.default), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'cases', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'category', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'id', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'name', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class2)) || _class;

var _default = LeadSourceModel;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LeadSourceModel, 'LeadSourceModel', '/app/src/models/LeadSourceModel.js');
  reactHotLoader.register(_default, 'default', '/app/src/models/LeadSourceModel.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9tb2RlbHMvTGVhZFNvdXJjZU1vZGVsLmpzIl0sIm5hbWVzIjpbIkxlYWRTb3VyY2VNb2RlbCIsImF1dG9CaW5kTWV0aG9kcyIsImRhdGEiLCJmbGF0U3RvcmUiLCJleHRlbmQiLCJTRVJJQUxJWkVfRklFTERTIiwiQmFzZU1vZGVsIiwib2JzZXJ2YWJsZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7OztBQUdBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lBR01BLGUsT0FETEMsZ0M7OztBQU9DO0FBQ0EsNkJBQW1DO0FBQUEsUUFBdEJDLElBQXNCLHVFQUFmLEVBQWU7QUFBQSxRQUFYQyxTQUFXOztBQUFBOztBQUFBLGtJQUMzQkEsU0FEMkI7O0FBQUE7O0FBQUE7O0FBQUE7O0FBQUE7O0FBRWpDLFVBQUtDLE1BQUwsQ0FBWUYsSUFBWjtBQUZpQztBQUdsQzs7OztnQ0FFWTtBQUNYLFVBQU1HLG1CQUFtQixDQUFDLE9BQUQsRUFBVSxVQUFWLEVBQXNCLElBQXRCLEVBQTRCLE1BQTVCLENBQXpCO0FBQ0EsYUFBTyxnQkFBSyxvQkFBSyxJQUFMLEVBQVdBLGdCQUFYLENBQUwsQ0FBUDtBQUNEOzs7Ozs7Ozs7OztFQWYyQkMsbUIseUVBQzNCQyxnQjs7O1dBQW1CLEU7OzZFQUNuQkEsZ0I7Ozt1RUFDQUEsZ0I7Ozt5RUFDQUEsZ0I7Ozs7O2VBY1lQLGU7Ozs7Ozs7Ozs7OzBCQWxCVEEsZSIsImZpbGUiOiJMZWFkU291cmNlTW9kZWwuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IG9ic2VydmFibGUsIHRvSlMgfSBmcm9tICdtb2J4JztcbmltcG9ydCBhdXRvQmluZE1ldGhvZHMgZnJvbSAnY2xhc3MtYXV0b2JpbmQtZGVjb3JhdG9yJztcbmltcG9ydCB7IHBpY2sgfSBmcm9tICdsb2Rhc2gnO1xuXG5pbXBvcnQgQmFzZU1vZGVsIGZyb20gJy4vQmFzZU1vZGVsJztcblxuQGF1dG9CaW5kTWV0aG9kc1xuY2xhc3MgTGVhZFNvdXJjZU1vZGVsIGV4dGVuZHMgQmFzZU1vZGVsIHtcbiAgQG9ic2VydmFibGUgY2FzZXMgPSBbXTtcbiAgQG9ic2VydmFibGUgY2F0ZWdvcnk7XG4gIEBvYnNlcnZhYmxlIGlkO1xuICBAb2JzZXJ2YWJsZSBuYW1lO1xuXG4gIC8vIGlzdGFuYnVsIGlnbm9yZSBuZXh0XG4gIGNvbnN0cnVjdG9yIChkYXRhID0ge30sIGZsYXRTdG9yZSkge1xuICAgIHN1cGVyKGZsYXRTdG9yZSk7XG4gICAgdGhpcy5leHRlbmQoZGF0YSk7XG4gIH1cblxuICBzZXJpYWxpemUgKCkge1xuICAgIGNvbnN0IFNFUklBTElaRV9GSUVMRFMgPSBbJ2Nhc2VzJywgJ2NhdGVnb3J5JywgJ2lkJywgJ25hbWUnXTtcbiAgICByZXR1cm4gdG9KUyhwaWNrKHRoaXMsIFNFUklBTElaRV9GSUVMRFMpKTtcbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBMZWFkU291cmNlTW9kZWw7XG4iXX0=